import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const api = axios.create({
  baseURL: API_URL,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

// ==== Active modules ====

export const greenCategories = {
  getAll: () => api.get('/green-categories'),
  create: (data) => api.post('/green-categories', data),
  update: (id, data) => api.patch(`/green-categories/${id}`, data),
  delete: (id) => api.delete(`/green-categories/${id}`),
};

export const greenIntakes = {
  getAll: (params = {}) => api.get('/green-intakes', { params }),
  create: (data) => api.post('/green-intakes', data),
  delete: (id) => api.delete(`/green-intakes/${id}`),
};

export const greenStockSnapshot = {
  get: (date) => api.get('/green-stock-snapshot', { params: date ? { date } : {} }),
};

export const roastRecords = {
  getAll: (params = {}) => api.get('/roast-records', { params }),
  create: (data) => api.post('/roast-records', data),
  delete: (id) => api.delete(`/roast-records/${id}`),
};

export const roastedStock = {
  getAll: () => api.get('/roasted-stock-v2'),
  getSummary: () => api.get('/roasted-stock-v2/summary'),
  getSnapshot: (date) => api.get('/roasted-stock-v2/snapshot', { params: date ? { date } : {} }),
};

export const coffeeDispatches = {
  getAll: (params = {}) => api.get('/coffee-dispatches', { params }),
  create: (data) => api.post('/coffee-dispatches', data),
  update: (id, data) => api.patch(`/coffee-dispatches/${id}`, data),
  delete: (id) => api.delete(`/coffee-dispatches/${id}`),
  getCosts: () => api.get('/dispatch-costs'),
};

export const blendNames = {
  getAll: () => api.get('/blend-names'),
};

export const clients = {
  getAll: () => api.get('/clients'),
  create: (data) => api.post('/clients', data),
  delete: (id) => api.delete(`/clients/${id}`),
};

export const reports = {
  pnl: (year, month) => api.get('/reports/pnl', { params: { year, month } }),
  monthlyPack: (year, month) => api.get('/reports/monthly-pack', { params: { year, month } }),
};

export const dashboard = {
  getSummary: () => api.get('/dashboard/summary-v2'),
};

export const profile = {
  updateProfile: (data) => api.patch('/auth/profile', data),
  changePassword: (data) => api.post('/auth/change-password', data),
};

export const wastage = {
  getAll: () => api.get('/wastage'),
  create: (data) => api.post('/wastage', data),
  update: (wasteId, data) => api.patch(`/wastage/${wasteId}`, data),
  delete: (wasteId) => api.delete(`/wastage/${wasteId}`),
  addNote: (wasteId, note) => api.post(`/wastage/${wasteId}/add-note`, { note }),
};

export const users = {
  getAll: () => api.get('/users'),
  getById: (id) => api.get(`/users/${id}`),
  create: (data) => api.post('/auth/register', data),
  update: (id, data) => api.patch(`/users/${id}`, data),
  delete: (id) => api.delete(`/users/${id}`),
  resetPassword: (id, newPassword) => api.patch(`/users/${id}/reset-password`, { new_password: newPassword }),
};

export const expenses = {
  getAll: () => api.get('/expenses'),
  create: (data) => api.post('/expenses', data),
  update: (expenseId, data) => api.patch(`/expenses/${expenseId}`, data),
  delete: (expenseId) => api.delete(`/expenses/${expenseId}`),
  addNote: (expenseId, note) => api.post(`/expenses/${expenseId}/add-note`, { note }),
  approve: (id, approve) => api.patch(`/expenses/${id}/approve`, null, { params: { approve } }),
};

export const cashAdvances = {
  create: (data) => api.post('/cash-advances', data),
  getAll: () => api.get('/cash-advances'),
  getUserBalance: (userEmail) => api.get(`/users/${userEmail}/cash-balance`),
  getAllUsersBalances: () => api.get('/cash-balances/all'),
};

export const activityLogs = {
  getAll: () => api.get('/activity-logs'),
  deleteOld: () => api.delete('/activity-logs/old'),
};

export const deletedItems = {
  getAll: () => api.get('/deleted-items'),
  restore: (itemId) => api.post(`/deleted-items/${itemId}/restore`),
  cleanup: () => api.delete('/deleted-items/cleanup'),
};
